export default __webpack_public_path__ + "static/media/left-arrow.ed50401f.svg";